import React, { useState, useEffect , useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Paginador from './Paginador';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import DialogConfirm from './DialogConfirm';

import FilterMain from './Filter/FilterMain';



import UpSpinner from '../FileUpload/UpSpinner';

import ReviewDetail from './ReviewDetail';


//lineasdetalletmp

import { ApiCallGet , ApiCallPost } from '../ApiCall/ApiCall';


export default function ReviewProduccion() {
    const [products, setProducts] = useState([]);
    const [start,setStart] = useState( 0 )
    const [limit,setLimit] = useState( { rows :10 , page : 0 } )
    const [min,setMin] = useState( 0 )
    const [max,setMax] = useState( 0 ) // El maximo de la consulta anterior
    const [count,setCount] = useState( 120 )
    const [records,setRecords] = useState([])
    const [show,setShow] = useState( false )
    const [isLoading,setIsLoading] = useState( false )
    const [params,setParams] = useState( null )
    const [filtro,setFiltro] = useState( false )
    const [query1,setQuery1] = useState("")
    const [query2,setQuery2] = useState("")
    const [nFiltro,setNFiltro] = useState( 0 );
    const [lastQuery,setLastQuery] = useState( "")
    const [saldos,setSaldos] = useState([])


    const toast = useRef() ;


    useEffect(() =>{

        console.log( "Ha cambiado el query2 " , query2 )

        //onProcesado()

    } , [query2])


    function onProcesado2(q)
    {
        console.log( "onProcesado2")
        onProcesado(q)
    }


    function onProcesado( q )
    {
        console.log( "onProcesado === " + query2 )

        //if ( query1 === "" && query2 === "")
        if ( q === null )
        {
            setNFiltro( 0 ) ; // Nos quedamos en el primero
            callTemporal(0,10)
            return ;
        }

        setLastQuery( q )

        setNFiltro( 1 ) ; // Nos vamos al siguiente nivel

        var body = {
            query1 : q.query1 ,
            query2 : limit
        }

        console.log( "body = " , body )


        setRecords( [])


        ApiCallPost( 'lineasdetallefiltro' , body ) 
        .then((response) => {
            console.log( response )

            if ( response === null )
            {

                setRecords( [])
                
                toast.current.show({ severity: 'warning', summary: 'Sin datos', detail: 'No se encontraron datos para este filtro' , life: 6000 });

                return ;
            }

            console.log( "count = " + response.count , " min " + response.min + " max = " + response.max  )

            setCount( response.count)

            console.log( "Respuesta con filtro = " , response.rows )


            for( var i = 0 ; i < response.rows.length ; i++ )
            {


                response.rows[i].fechaactivacion = new Date( response.rows[i].fechaactivacion )

                response.rows[i].fechaactivacion = addHoursToDate(response.rows[i].fechaactivacion , 6); 

                response.rows[i].fechaactivacion = getFormatDateShort( response.rows[i].fechaactivacion ) 


                if ( response.rows[i].fechaexpiracion !== null )
                {
                    response.rows[i].fechaexpiracion = new Date( response.rows[i].fechaexpiracion )
                    response.rows[i].fechaexpiracion = addHoursToDate(response.rows[i].fechaexpiracion , 6);
                    response.rows[i].fechaexpiracion = getFormatDateShort( response.rows[i].fechaexpiracion )
                }



                if ( response.rows[i].fechaprimerevento !== null )
                {
                    response.rows[i].fechaprimerevento = new Date( response.rows[i].fechaprimerevento )
                    response.rows[i].fechaprimerevento = addHoursToDate(response.rows[i].fechaprimerevento , 6);
                }

                response.rows[i].fechaprimerevento = ( response.rows[i].fechaprimerevento === null || response.rows[i].fechaprimerevento === undefined || isNaN( response.rows[i].fechaprimerevento )? null : getFormatDateShort( response.rows[i].fechaprimerevento ) ) 


                if ( response.rows[i].fechaprimerrecarga !== null )
                {
                    response.rows[i].fechaprimerrecarga = new Date( response.rows[i].fechaprimerrecarga )
                    response.rows[i].fechaprimerrecarga = addHoursToDate(response.rows[i].fechaprimerrecarga , 6);
                }

                response.rows[i].fechaprimerrecarga = ( response.rows[i].fechaprimerrecarga === null ? null : getFormatDateShort( response.rows[i].fechaprimerrecarga ) ) 

                console.log( "response.rows[i].fechaultimarecarga = " , response.rows[i].fechaultimarecarga)

                if ( response.rows[i].fechaultimarecarga !== null )
                {
                    response.rows[i].fechaultimarecarga = new Date( response.rows[i].fechaultimarecarga )
                    response.rows[i].fechaultimarecarga = addHoursToDate(response.rows[i].fechaultimarecarga , 6);
                }
    
                                
                response.rows[i].fechaultimarecarga = ( response.rows[i].fechaultimarecarga === null ? null : getFormatDateShort( response.rows[i].fechaultimarecarga ))

                //response.rows[i].saldo = "$$" + getSaldo( response.rows[i].diasrecargados ) +".00" 

                response.rows[i].saldo = "$" + response.rows[i].saldo +".00" 



            }


            //console.log( "fechaultimarecarga  = ****" , response.rows[i].fechaultimarecarga )
    


            setRecords( response.rows )

            //setFiltro( !filtro )
        })
        .catch( (err) => {
            console.log( err ) ;
        })
    }



    function setQ1( val )
    {
        setQuery1( val )
    }

    function setQ2( val )
    {
        console.log( "sqtQ2 = " , val )
        setQuery2( val )
    }

    


    function onFiltro()
    {
        console.log( "onFiltro")
        setFiltro( !filtro ) ;
    }

    useEffect(() =>{
        console.log( "se detecto cambio de params")
    } , [params])


    function onRowSelect(e)
    {
        console.log( "onRowSelect " , e )
    }

    useEffect(() => {

        ApiCallGet( "saldos" )
        .then((response) => {

            console.log( "Saldos = " , response )

            setSaldos( response ) ;

        })
        .catch((err) => {

            console.log( err )

        })
        .finally( () =>{
        }
            
        )

    } , [])

    useEffect(() => {
            console.log( "Use Effect [saldos] Llamando a temporal")
            callTemporal(0,10)

    } , [saldos])

    function getSaldo( dias)
    {

        console.log( "saldos length = " , saldos.length )

        for( var i = 0 ; i < saldos.length ; i++ )
        {
            console.log( "nDias = " + saldos[i].nDias + " dias = " + dias )
            if ( saldos[i].nDias > dias  )
            {
                if ( i === 0 )
                {
                    return 0 
                }
                return saldos[i].mRecarga
            }
        }
        return saldos[saldos.length-1].mRecarga
    }

    function onAnswer( val )
    {
        console.log( "onAnswer = " , val )

        if ( val === true )
        {
            setIsLoading( true )
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Iniciando Carga de Archivo' });


            ApiCallPost('moveproduction' , { user : 'Digital'})
            .then((response)=>{

                setIsLoading( false )
                console.log( 'moveproduction' , response )

                toast.current.show({ severity: 'info', summary: 'Success', detail: 'Archivo Cargado' });


            })
            .catch((err)=>{

                console.log( err )

                setIsLoading( false )

                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar archivo' , life: 6000 });


            })

        }

    }

 

    function onRowClick( val)
    {
        console.log( "onRowClick = " , val.data )

        setParams( val.data )

        
    }

    function onChangeValues( val )
    {

        console.log( "max = " + max  )

        console.log( "values = " , val )

        //setLimit( val.rows )
        //setMax( val.first )
        setLimit( val )

        //callTemporal( records[records.length-1].id , val.rows )

        if ( nFiltro === 0 )
        {
            callTemporal( val.rows * val.page  , val.rows )
        }

        if ( nFiltro === 1 )
        {
            onProcesado( lastQuery )
        }
        


    }

    useEffect(() => {

        //console.log( "Se recargo la pagina")

        //callTemporal(0,10)
        
    }, []);

    function callTemporal( start , recs ) // Aqui solo va para arriba
    {
        console.log( "temporal = atart = " + start + " recs = " + recs  )

        setRecords( [])

        ApiCallGet( "lineasdetalle?start=" + start + "&limit=" + recs  )
        .then((response)=> {

            console.log( "count = " + response.count , " min " + response.min + " max = " + response.max  )

            setCount( response.count)

            //console.log( "response = ****" , response )

            //setMin( min => response.min )
            //setMax( max => response.max )

            for( var i = 0 ; i < response.rows.length ; i++ )
            {


                response.rows[i].fechaactivacion = new Date( response.rows[i].fechaactivacion )

                response.rows[i].fechaactivacion = addHoursToDate(response.rows[i].fechaactivacion , 6); 

                response.rows[i].fechaactivacion = getFormatDateShort( response.rows[i].fechaactivacion ) 


                response.rows[i].fechaexpiracion = new Date( response.rows[i].fechaexpiracion )

                response.rows[i].fechaexpiracion = addHoursToDate(response.rows[i].fechaexpiracion , 6);

                response.rows[i].fechaexpiracion = getFormatDateShort( response.rows[i].fechaexpiracion )

                if ( response.rows[i].fechaprimerevento !== null )
                {
                    response.rows[i].fechaprimerevento = new Date( response.rows[i].fechaprimerevento )
                    response.rows[i].fechaprimerevento = addHoursToDate(response.rows[i].fechaprimerevento , 6);
                }

                response.rows[i].fechaprimerevento = ( response.rows[i].fechaprimerevento === null || response.rows[i].fechaprimerevento === undefined || isNaN( response.rows[i].fechaprimerevento )? null : getFormatDateShort( response.rows[i].fechaprimerevento ) ) 


                if ( response.rows[i].fechaprimerrecarga !== null )
                {
                    response.rows[i].fechaprimerrecarga = new Date( response.rows[i].fechaprimerrecarga )
                    response.rows[i].fechaprimerrecarga = addHoursToDate(response.rows[i].fechaprimerrecarga , 6);
                }

                response.rows[i].fechaprimerrecarga = ( response.rows[i].fechaprimerrecarga === null ? null : getFormatDateShort( response.rows[i].fechaprimerrecarga ) ) 


                if ( response.rows[i].fechaultimarecarga !== null )
                {
                    response.rows[i].fechaultimarecarga = new Date( response.rows[i].fechaultimarecarga )
                    response.rows[i].fechaultimarecarga = addHoursToDate(response.rows[i].fechaultimarecarga , 6);
                }
    
                              
                response.rows[i].fechaultimarecarga = ( response.rows[i].fechaultimarecarga === null ? null : getFormatDateShort( response.rows[i].fechaultimarecarga ))

                //response.rows[i].saldo = "$$$" + getSaldo( response.rows[i].diasrecargados ) +".00"
                response.rows[i].saldo = "$" + response.rows[i].saldo  +".00"


            }

            setRecords( response.rows )

        })
        .catch((err)=>{
            console.log( err )
        })

    }

    // Date.prototype.addHours = function(h) {
    //     this.setTime(this.getTime() + (h*60*60*1000));
    //     return this;
    //   }

    function addHoursToDate(date, hours) {

        //console.log( "type = " , typeof( date ))

        return new Date(date.getTime() + hours * 60 * 60 * 1000);
    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
          ("00" + date.getHours()).slice(-2) + ":" +
          ("00" + date.getMinutes()).slice(-2) + ":" +
          ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
      
        return dateStr;
      }

      function getFormatDateShort(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2)  
 
        //console.log(dateStr);
      
        return dateStr;
      }

    return (
        <div className="card" >

            <Toast ref={toast} />

            <div className='flex justify-content-center'>
                <h3>Revisión de Datos Producción</h3>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button onClick={onFiltro} className=' mt-3 pb-2 pt-2' label='Filtros' style={{height:'30px'}}></Button>
            </div>

            <div>
                <FilterMain setQ1={setQ1} setQ2={setQ2} show={filtro} procesado={(val) =>onProcesado2(val)}></FilterMain>
            </div>

            {
                isLoading === true && (
                    <UpSpinner></UpSpinner>
                )

            }

            <div style={{overflowY :'scroll', height : '74vh'}}>

            <DataTable value={records} onRowSelect={(e) => onRowSelect(e)}
                stripedRows scrollable={true}
                tableStyle={{ minWidth: '50rem' }} onRowClick={(val) => onRowClick(val)}>
                <Column field="id" header="Id"></Column>
                <Column field="numero" header="Telefono"></Column>
                <Column field="fechaactivacion" header="Fecha Activación"></Column>
                <Column field="iccid" header="Iccid"></Column>
                <Column field="ofertaprimaria" header="Oferta Primaria"></Column>
                <Column field="estatus" header="Estatus"></Column>
                <Column field="fechaprimerevento" header="Fecha Primer Evento"></Column>
                <Column field="fechaexpiracion" header="Fecha Expiración"></Column>
                {/* // fechaprimerrecarga , numeroderecargas , fechaultimarecarga , diasrecargados , saldo  */}
                <Column field="fechaprimerrecarga" header="Fecha primer Recarga"></Column>
                <Column field="numeroderecargas" header="Número de Recargas"></Column>
                <Column field="fechaultimarecarga" header="Fecha última Recarga"></Column>
                <Column field="diasrecargados" header="Dias Recargados"></Column>
                <Column field="saldo" header="Saldo"></Column>

            </DataTable>
            </div>

            <Paginador theFirst={min} setTheRows={(val) => onChangeValues( val )} theRecords={count}></Paginador>

            <ReviewDetail  record={params}></ReviewDetail>
{/* 
            <div className='flex justify-content-center'>
                <Button onClick={onProduccion} label="Subir a Producción"></Button>
            </div>

            <div className='mt-5'>
                <DialogConfirm show={show} answer={onAnswer}></DialogConfirm> 
            </div>  */}


            
        </div>
    );
}

// select id ,  idmaster , fechaactivacion , imei , ofertaprimaria , estatus , ( select numero from lineasdatamaster datamaster where id = idmaster  ) as numero  from lineasdatadetalletmp where id > ? limit ?"
